const data = {
  products: [
    {
      id: 1,
      name: "Absolute vodka",
      category: "vodka",
      price: 289.99,
      litres: "750ml",
      available: false,
      image: "https://asandahdevs.github.io/Amabele/Images/Absolut_vodka.webp",
    },
    {
      id: 2,
      name: "Amarula fruit cream",
      category: "other",
      price: 164.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Amarula_fruit_cream.webp",
    },
    {
      id: 3,
      name: "Bains whiskey",
      category: "whiskey",
      price: 229.0,
      litres: "750ml",
      available: true,
      image: "https://asandahdevs.github.io/Amabele/Images/Bains_whiskey.webp",
    },
    {
      id: 4,
      name: "Ballantine whiskey",
      category: "whiskey",
      price: 259.0,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Ballantine_whiskey.webp",
    },
    {
      id: 5,
      name: "Bernini Blush cider",
      category: "cider",
      price: 85.0,
      litres: "275ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Bernini_Blush_cider.webp",
    },
    {
      id: 6,
      name: "Black river coffee stout",
      category: "stout",
      price: 34.99,
      litres: "440ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Black_river_coffee_stout.webp",
    },
    {
      id: 7,
      name: "Brutal fruit cider",
      category: "cider",
      price: 79.99,
      litres: "275ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Brutal_fruit_cider.webp",
    },
    {
      id: 8,
      name: "Castle milk stout (chocolate flavour)",
      category: "stout",
      price: 21.99,
      litres: "750ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Castle_Milk_Stout_chocolate.webp",
    },
    {
      id: 9,
      name: "Ciroc vodka",
      category: "vodka",
      price: 529.0,
      litres: "750ml",
      available: true,
      image: "https://asandahdevs.github.io/Amabele/Images/Ciroc_Vodka.webp",
    },
    {
      id: 10,
      name: "Cruz vodka",
      category: "vodka",
      price: 259.0,
      litres: "750ml",
      available: true,
      image: "https://asandahdevs.github.io/Amabele/Images/Cruz_Vodka.webp",
    },
    {
      id: 11,
      name: "Drostdy hof",
      category: "wine",
      price: 48,
      litres: "750ml",
      available: true,
      image: "https://asandahdevs.github.io/Amabele/Images/Drostdy_hof.webp",
    },
    {
      id: 12,
      name: "4 cousins red wine",
      category: "wine",
      price: 99.99,
      litres: "1.5L",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/four_cousins_red_wine.webp",
    },
    {
      id: 13,
      name: "4 cousins white wine ",
      category: "wine",
      price: 52.99,
      litres: "750ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Four_cousins_White_Wine.webp",
    },
    {
      id: 14,
      name: "4th street red wine",
      category: "wine",
      price: 139.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Fourth_Street_Red_Wine.webp",
    },
    {
      id: 15,
      name: "Guiness foreign extra stout",
      category: "stout",
      price: 60,
      litres: "600ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Guiness_foreign_extra_stout.webp",
    },
    {
      id: 16,
      name: "hunters dry cider",
      category: "cider",
      price: 24.99,
      litres: "660ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/hunters_dry_cider.webp",
    },
    {
      id: 17,
      name: "hunters gold cider",
      category: "cider",
      price: 16.99,
      litres: "330ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/hunters_gold_cider.webp",
    },
    {
      id: 18,
      name: "Jack Daniels whiskey",
      category: "whiskey",
      price: 299.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Jack_Daniels_Whiskey.webp",
    },
    {
      id: 19,
      name: "Jameson irish whiskey",
      category: "whiskey",
      price: 369.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Jameson_irish_whiskey.webp",
    },
    {
      id: 20,
      name: "Johnnie Walker black label whiskey",
      category: "whiskey",
      price: 519.99,
      litres: "750ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Johnnie_Walker_Black_Label_Whiskey.webp",
    },
    {
      id: 21,
      name: "Jonnie walker red label blended scotch whiskey",
      category: "wine",
      price: 344.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/johnnie_walker_red_label_blended_scotch_whisky.webp",
    },
    {
      id: 22,
      name: "Red square vodka",
      category: "vodka",
      price: 154.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Red_square_vodka.webp",
    },
    {
      id: 23,
      name: "Robertson natural sweet red wine",
      category: "wine",
      price: 54.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Robertson_Natural_Sweet_Red_Wine.webp",
    },
    {
      id: 24,
      name: "Rose cider",
      category: "cider",
      price: null,
      litres: "750ml",
      available: false,
      image: "https://asandahdevs.github.io/Amabele/Images/Rose_cider.webp",
    },
    {
      id: 25,
      name: "Russian bear vodka",
      category: "vodka",
      price: 154.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Russian_bear_Vodka.webp",
    },
    {
      id: 26,
      name: "Saint Joseph red wine",
      category: "wine",
      price: 44.99,
      litres: "750ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Saint_Joseph_Red_Wine.webp",
    },
    {
      id: 27,
      name: "Saint Rapheal red wine",
      category: "wine",
      price: 44.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Saint_Rapheal_Red_Wine.webp",
    },
    {
      id: 28,
      name: "Savanna dry cider",
      category: "cider",
      price: 18.99,
      litres: "330ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/SAVANNA_DRY_CIDER.webp",
    },
    {
      id: 29,
      name: "Skyy_Vodka",
      category: "vodka",
      price: 249.99,
      litres: "750ml",
      available: true,
      image: "https://asandahdevs.github.io/Amabele/Images/Skyy_Vodka.webp",
    },
    {
      id: 30,
      name: "Smirnoff 1818 vodka",
      category: "vodka",
      price: 149.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/smirnoff_1818_vodka.webp",
    },
    {
      id: 31,
      name: "Smirnoff raspberry and pomegranate cider",
      category: "cider",
      price: null,
      litres: "750ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/smirnoff_rasberryy_and_promegranite_cider.webp",
    },
    {
      id: 32,
      name: "Strongbow rose cider",
      category: "cider",
      price: 94.99,
      litres: "330ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/strongbow_small_rose cider.webp",
    },
    {
      id: 33,
      name: "The Glenlivet 12 YO Single Malt Scotch",
      category: "whiskey",
      price: 539.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/The_glenlivet_single_malt_scotch_whiskey.webp",
    },
    {
      id: 34,
      name: "Three ships mash tun whiskey",
      category: "whiskey",
      price: 124.99,
      litres: "750ml",
      available: true,
      image:
        "https://asandahdevs.github.io/Amabele/Images/three_ships_mash_tun.webp",
    },
    {
      id: 35,
      name: "Two oceans sauvignon blanc white wine",
      category: "wine",
      price: 48.99,
      litres: "750ml",
      available: false,
      image:
        "https://asandahdevs.github.io/Amabele/Images/Two_Oceans_Sauvignon_Blanc_White_Wine.webp",
    },
  ],
};

export default data;
